import axios from "axios";
import { BASE_API_POS } from "../config";

const ZNS_API_URL = "/api/v1/Zns/send";
const ZNS_FROM = "2761260980408892837";

export const ZNS_TEMPLATE_IDS = {
  ORDER_COMPLETED: "423365",
  ORDER_OUTWARD: "602489",
  ORDER_CANCELLED: "418987",
} as const;

export type ZnsTemplateData = Record<string, string | number | null | undefined>;

export interface ZnsPayload {
  from: string;
  to: string;
  template_id: string;
  template_data: ZnsTemplateData;
  client_req_id: string;
  dlr?: number;
  rsa?: number;
  sending_mode?: number;
}

export const normalizeZnsPhoneNumber = (phone?: string | number | null) => {
  const digits = String(phone ?? "").replace(/\D/g, "");

  if (!digits) return "";
  if (digits.startsWith("84")) return digits;
  if (digits.startsWith("0")) return `84${digits.slice(1)}`;

  return digits;
};

const removeEmptyTemplateData = (templateData: ZnsTemplateData) =>
  Object.entries(templateData).reduce<ZnsTemplateData>((result, [key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      result[key] = value;
    }

    return result;
  }, {});

export const createZnsPayload = (
  clientReqId: string,
  templateId: string,
  templateData: ZnsTemplateData,
  phone: string | number | null | undefined,
): ZnsPayload => ({
  from: ZNS_FROM,
  to: normalizeZnsPhoneNumber(phone),
  template_id: templateId,
  template_data: removeEmptyTemplateData(templateData),
  client_req_id: clientReqId,
});

export const sendZnsMessage = async (payload: ZnsPayload) => {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(`${BASE_API_POS}${ZNS_API_URL}`, payload, {
      headers: {
        Authorization: `Bearer ${token?.replace(/^"|"$/g, "")}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return response.data;
  } catch (error: any) {
    return (
      error?.response?.data || {
        success: false,
        message: error?.message || "Gui ZNS that bai",
      }
    );
  }
};
